<template>
  <div>
    <PriciInfoCard :priceInfo="priceInfo" v-for="(priceInfo,i) in priceBookList" :key="i" />
  </div>
</template>


<script>
import PriciInfoCard from "./PriceInfoCard.vue";
export default {
  props: {
    priceBookList: {
      type: Array
    }
  },
  components: {
    PriciInfoCard
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/priceList/parts/PriceBookList.vue